import { Chip, Tooltip } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCredits } from '../../contexts/CreditContext';
import { formatNumber } from '../../i18n/format';

/**
 * Header credit balance (every tier). Shows total available credits; turns
 * amber below 10% of the monthly allocation. Click → top-up modal (agency) or
 * the credit history (other tiers: no top-up).
 */
export default function CreditBalanceChip() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAgency, hasCredits, balance, openTopup } = useCredits();
  if (!hasCredits || !balance) return null;

  const { available, subscriptionCredits, topupCredits, monthlyAllocation } = balance;
  const low = monthlyAllocation ? available < monthlyAllocation * 0.1 : available <= 0;

  const tooltipTitle =
    (isAgency
      ? t('creditChip.tooltip', { subscription: subscriptionCredits, topup: topupCredits })
      : t('creditChip.tooltipSelfServe', { subscription: subscriptionCredits })) +
    (balance.reserved ? t('creditChip.tooltipReserved', { reserved: balance.reserved }) : '');

  return (
    <Tooltip title={tooltipTitle}>
      <Chip
        data-tour="credit-balance"
        icon={<BoltIcon fontSize="small" />}
        label={t('creditChip.label', { credits: formatNumber(available) })}
        size="small"
        color={low ? 'warning' : 'default'}
        variant={low ? 'filled' : 'outlined'}
        onClick={() => (isAgency ? openTopup() : navigate('/credits/ledger'))}
        sx={{ fontWeight: 600, cursor: 'pointer' }}
      />
    </Tooltip>
  );
}
